import { RouteProps } from 'react-router-dom';
import { useEffect } from 'react';

import { setWindowLocation } from '../../common/helpers';
import UI from '../../common/UI';

interface BrowserRedirectProps extends RouteProps {
  to: string;
}

/**
 * Redirects the user by changing the window.location oject.
 */
const BrowserRedirect = ({ to }: BrowserRedirectProps) => {
  useEffect(() => {
    setWindowLocation(to);
  }, [to]);

  return (
    <UI.PageLoader />
  );
};

export default BrowserRedirect;
